import React from 'react';
import { useTranslation } from "react-i18next";
import { Card, CardContent, CardHeader, CardTitle } from "components/ui/card";
import { AlertTriangle, Package } from "lucide-react";
import { Badge } from "components/ui/badge";
import { getReorderRatio, isBelowReorderPoint } from "utils";

export default function LowStockAlert({ inventoryItems }) {
  const { t } = useTranslation();
  const lowStockItems = inventoryItems.filter(
    isBelowReorderPoint
  ).sort((a, b) => {
    return getReorderRatio(a) - getReorderRatio(b);
  }).slice(0, 5);

  const getStockLevel = (item) => {
    const percent = getReorderRatio(item) * 100;
    if (percent <= 25) return { label: t("dashboard.critical"), color: 'bg-red-100 text-red-700 border-red-200' };
    if (percent <= 50) return { label: t("dashboard.low"), color: 'bg-orange-100 text-orange-700 border-orange-200' };
    return { label: t("dashboard.attention"), color: 'bg-yellow-100 text-yellow-700 border-yellow-200' };
  };

  return (
    <Card className="border-0 shadow-md">
      <CardHeader className="pb-4">
        <CardTitle className="text-lg font-bold text-slate-900 flex items-center gap-2">
          <AlertTriangle className="w-5 h-5 text-orange-500" />
          {t("dashboard.lowStockAlert")}
        </CardTitle>
      </CardHeader>
      <CardContent className="pt-0">
        {lowStockItems.length === 0 ? (
          <div className="text-center py-8">
            <Package className="w-12 h-12 text-slate-300 mx-auto mb-2" />
            <p className="text-slate-500 text-sm">{t("dashboard.allStockSufficient")}</p>
          </div>
        ) : (
          <div className="space-y-3">
            {lowStockItems.map((item) => {
              const stockLevel = getStockLevel(item);
              return (
                <div key={item.id} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg hover:bg-slate-100 transition-colors">
                  <div className="flex-1">
                    <p className="font-semibold text-slate-900 text-sm">{item.name}</p>
                    <p className="text-xs text-slate-500 mt-1">
                      {t("dashboard.stock")}: <span className="font-medium">{item.current_quantity} {item.unit}</span> 
                      <span className="mx-2">•</span>
                      {t("dashboard.minimum")}: {item.reorder_point} {item.unit}
                    </p>
                  </div>
                  <Badge className={`${stockLevel.color} border font-semibold`}>
                    {stockLevel.label}
                  </Badge>
                </div>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
